import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SingleChargeNotificationPreferencesResponse {
  /**
   * Notification e-mail address.
   */
  @observable
  notificationEmailAddress?: string;

  /**
   * Notification phone number.
   */
  @observable
  notificationPhoneNumber?: string;

  /**
   * Indicates if notifications by e-mail are enabled.
   */
  @observable
  emailNotificationEnabled!: boolean;

  /**
   * Indicates if SMS notifications are enabled.
   */
  @observable
  smsNotificationEnabled!: boolean;
}
